import { createPendingConfirmations } from '@arkade-os/lnurl-client'

export const pendingConfirmations = createPendingConfirmations()
